<div
  aria-label="loading"
  class="inline-block size-8 animate-spin rounded-full border-[3px] border-current border-b-primary-100 border-l-primary-100 text-primary"
  role="status"
>
  <span class="sr-only">Loading</span>
</div>
